var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "90px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ColumnNumber"),
            prop: "columnIndex",
          },
        },
        [
          _c("BjInputNumber", {
            attrs: { min: 0, "not-auto-zero": "" },
            model: {
              value: _vm.form.columnIndex,
              callback: function ($$v) {
                _vm.$set(_vm.form, "columnIndex", $$v)
              },
              expression: "form.columnIndex",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ColumnCode"),
            prop: "columnCode",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.columnCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "columnCode", $$v)
              },
              expression: "form.columnCode",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ColumnName"),
            prop: "columnName",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.columnName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "columnName", $$v)
              },
              expression: "form.columnName",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ColumnType"),
            prop: "columnType",
          },
        },
        [
          _c("BjSelectLov", {
            attrs: { "lov-code": "HIMP.TEMPLATE.COLUMNTYPE" },
            model: {
              value: _vm.form.columnType,
              callback: function ($$v) {
                _vm.$set(_vm.form, "columnType", $$v)
              },
              expression: "form.columnType",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.FormatMask"),
            prop: "formatMask",
          },
        },
        [
          _c("BjDateTimerPicker", {
            model: {
              value: _vm.form.formatMask,
              callback: function ($$v) {
                _vm.$set(_vm.form, "formatMask", $$v)
              },
              expression: "form.formatMask",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.Length"),
            prop: "length",
          },
        },
        [
          _c("BjInputNumber", {
            attrs: { min: 0, "not-auto-zero": "" },
            model: {
              value: _vm.form.length,
              callback: function ($$v) {
                _vm.$set(_vm.form, "length", $$v)
              },
              expression: "form.length",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.Maximum"),
            prop: "minValue",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.minValue,
              callback: function ($$v) {
                _vm.$set(_vm.form, "minValue", $$v)
              },
              expression: "form.minValue",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.Minimum"),
            prop: "maxValue",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.maxValue,
              callback: function ($$v) {
                _vm.$set(_vm.form, "maxValue", $$v)
              },
              expression: "form.maxValue",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ValidateValue"),
            prop: "validateSet",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.validateSet,
              callback: function ($$v) {
                _vm.$set(_vm.form, "validateSet", $$v)
              },
              expression: "form.validateSet",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.RegularExpression"),
            prop: "regularExpression",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.regularExpression,
              callback: function ($$v) {
                _vm.$set(_vm.form, "regularExpression", $$v)
              },
              expression: "form.regularExpression",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.SampleData"),
            prop: "sampleData",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.sampleData,
              callback: function ($$v) {
                _vm.$set(_vm.form, "sampleData", $$v)
              },
              expression: "form.sampleData",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.Description"),
            prop: "description",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("enableText"), prop: "enabledFlag" } },
        [
          _c("el-switch", {
            attrs: { "active-value": 1, "inactive-value": 0 },
            model: {
              value: _vm.form.enabledFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "enabledFlag", $$v)
              },
              expression: "form.enabledFlag",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.NullAllowed"),
            prop: "nullableFlag",
          },
        },
        [
          _c("el-switch", {
            attrs: { "active-value": 1, "inactive-value": 0 },
            model: {
              value: _vm.form.nullableFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "nullableFlag", $$v)
              },
              expression: "form.nullableFlag",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.DataValidation"),
            prop: "validateFlag",
          },
        },
        [
          _c("el-switch", {
            attrs: { "active-value": 1, "inactive-value": 0 },
            model: {
              value: _vm.form.validateFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "validateFlag", $$v)
              },
              expression: "form.validateFlag",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("BusinessImportHistory.page.ValueConversion"),
            prop: "changeDataFlag",
          },
        },
        [
          _c("el-switch", {
            attrs: { "active-value": 1, "inactive-value": 0 },
            model: {
              value: _vm.form.changeDataFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "changeDataFlag", $$v)
              },
              expression: "form.changeDataFlag",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }